import React from "react";
import PropTypes from 'prop-types';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import _ from '../../../utils/ObjectUtils';

const DateTimeField =
    ({
         value = "",
         label = "",
         handleFieldChange,
         handleFieldBlur = () => {
         },
         error,
         disabled = false
     }) => {
        return (
            <FormControl
                error={!_.isNilOrEmpty(error)}
                disabled={disabled}
            >
                <InputLabel
                    color="primary"
                    htmlFor="adornment-label"
                    shrink
                >
                    {label}
                </InputLabel>
                <Input
                    id="adornment-label"
                    value={value}
                    type='datetime-local'
                    onChange={e => handleFieldChange(e.target.value)}
                    onBlur={handleFieldBlur}
                    aria-describedby="label-helper-text"
                    inputProps={{
                        "aria-label": "label",
                    }}
                />
                <FormHelperText id="label-helper-text">{error}</FormHelperText>
            </FormControl>
        );
    };

DateTimeField.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    handleFieldChange: PropTypes.func.isRequired,
    handleFieldBlur: PropTypes.func,
    error: PropTypes.string,
    themeName: PropTypes.string
};

export default DateTimeField;